import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

interface FooterState {
  data: any;
  loading: boolean;
  error: string | null;
}

const initialState: FooterState = {
  data: null,
  loading: false,
  error: null,
};

const NEXT_PUBLIC_REACT_APP_API_BASE_URL =
  process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;
// Async thunk to fetch footer content
export const fetchFooter = createAsyncThunk("footer/fetchFooter", async () => {
  // const response = await fetch("http://localhost:1337/api/footer-new-design?populate=all", { credentials: "include" });
  const response = await fetch(
    `${NEXT_PUBLIC_REACT_APP_API_BASE_URL}footer-new-design?populate=deep, 8`,
  );

  const data = await response.json();
  // return data?.data?.footerNewDesign; // adjust based on your API
  return data?.data?.attributes//?.footerNewDesign; // adjust based on your API
});

const footerSlice = createSlice({
  name: "footer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFooter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFooter.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchFooter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch footer";
      });
  },
});

export default footerSlice.reducer;
